import Flickity from './vendor/flickity';

const initCarouselBlocks = () => {
	const carousels = document.querySelectorAll('.block-carousel .carousel');

	carousels.forEach((carousel) => {
		if (carousel.dataset.carouselInitialized) return;

		const counterEl = carousel.closest('.block-carousel__inner').querySelector('.carousel__counter');

		const flickityInstance = new Flickity(carousel, {
			cellAlign: 'center',
			freeScroll: false,
			wrapAround: false,
			contain: false,
			pageDots: false,
			prevNextButtons: true,
			groupCells: false,
			draggable: true,
			selectedAttraction: 0.08,
			friction: 0.6,
		});

		// Override Flickity's inline overflow:hidden on viewport
		const viewport = carousel.querySelector('.flickity-viewport');
		if (viewport) {
			viewport.style.overflow = 'visible';
		}

		// Replace default nav button SVGs with Material Design chevron arrows
		const updateNavArrows = () => {
			const prevBtn = carousel.querySelector('.flickity-prev-next-button.previous');
			const nextBtn = carousel.querySelector('.flickity-prev-next-button.next');

			if (prevBtn) prevBtn.setAttribute('aria-label', 'Previous slide');
			if (nextBtn) nextBtn.setAttribute('aria-label', 'Next slide');

			const basePath = `${window.location.origin}/wp-content/themes/umces/custom-blocks/carousel/assets`;

			Promise.all([
				fetch(`${basePath}/arrow-back.svg`).then((r) => r.text()),
				fetch(`${basePath}/arrow-forward.svg`).then((r) => r.text()),
			]).then(([backSvg, forwardSvg]) => {
				if (prevBtn) prevBtn.innerHTML = backSvg;
				if (nextBtn) nextBtn.innerHTML = forwardSvg;
			}).catch((err) => console.error('Failed to load SVG:', err));
		};
		updateNavArrows();

		// Build controls container: move prev/next buttons and counter into a flex wrapper
		const buildControls = () => {
			const prevBtn = carousel.querySelector('.flickity-prev-next-button.previous');
			const nextBtn = carousel.querySelector('.flickity-prev-next-button.next');
			if (!prevBtn || !nextBtn || !counterEl) return;

			const controls = document.createElement('div');
			controls.className = 'carousel__controls';
			controls.appendChild(prevBtn);
			controls.appendChild(counterEl);
			controls.appendChild(nextBtn);
			carousel.after(controls);
		};
		buildControls();

		// Counter logic
		const updateCounter = () => {
			if (!counterEl) return;
			const slideNum = flickityInstance.selectedIndex + 1;
			const totalSlides = flickityInstance.slides.length;
			counterEl.textContent = `${slideNum}/${totalSlides}`;
		};

		// Caption fade — use opacity only, no display changes, no layout shift
		const updateCaptions = () => {
			const slides = carousel.querySelectorAll('.carousel__slide');

			slides.forEach((slide, index) => {
				const caption = slide.querySelector('.carousel__caption');
				if (!caption) return;

				if (index === flickityInstance.selectedIndex) {
					caption.style.opacity = '1';
					caption.style.visibility = 'visible';
				} else {
					caption.style.opacity = '0';
					caption.style.visibility = 'hidden';
				}
			});
		};

		// Run on init
		setTimeout(() => {
			updateCounter();
			updateCaptions();
		}, 0);

		flickityInstance.on('ready', () => {
			updateCounter();
			updateCaptions();
		});

		flickityInstance.on('change', () => {
			updateCounter();
			updateCaptions();

			// Announce slide change to screen readers
			const liveRegion = carousel.closest('.block-carousel').querySelector('.carousel__sr-announce');
			if (liveRegion) {
				liveRegion.textContent = `Slide ${flickityInstance.selectedIndex + 1} of ${flickityInstance.slides.length}`;
			}
		});

		carousel.dataset.carouselInitialized = true;
	});
};

// DOM ready
document.addEventListener('DOMContentLoaded', initCarouselBlocks);

// Gutenberg block preview support
if (window.acf) {
	window.acf.addAction('render_block_preview/type=carousel', initCarouselBlocks);
}
